// extracted by mini-css-extract-plugin
export default {"about-container":"About_about-container__azLLi","brand-highlight":"About_brand-highlight__vdbaV","about-text":"About_about-text__ptn+3"};